import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";

export const useFinancialInformation = () => {
    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingFinancialInformation>();

    const formProps: HighRiskMerchant.FinancialInformation.OnboardingFinancialInformationForm = {
        bootstrapData: {
            maxTransactionVolumeMonth: [
                '0 - 50,000',
                '50,001 - 100,000',
                '100,001 - 500,000',
                '500,001 - 1,000,000',
                '1,000,001+'
            ],
            salesVolumeCurrentMonth: [
                '0 - 50,000',
                '50,001 - 100,000',
                '100,001 - 500,000',
                '500,001 - 1,000,000',
                '1,000,001+'
            ],
            expectedSalesVolumeMonth: [
                '0 - 50,000',
                '50,001 - 100,000',
                '100,001 - 500,000',
                '500,001 - 1,000,000',
                '1,000,001+'
            ]
        },
        initialValues: HighRiskMerchant.FinancialInformation.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: () => {
            alert('Not implemented yet please wait for the update.');
        }
    };

    return {
        ...formProps,
        ...HighRiskMerchant.FinancialInformation.useForm(formProps),
        ...data
    };
};

export default useFinancialInformation;
